"use strict";

var PropTypes = require("prop-types");

var LoggerInstance = require("js-logger").get("DonationAmount");
var React = require("react");

var CheckoutActions = require("./CheckoutActions");
var CheckoutStore = require("./CheckoutStore");
var WizardConstants = require("../constants/WizardConstants");
var Constants = require("../designer/Constants");

var ActionsHelper = require("../actions/ActionsHelper");

var InputHelper = require("../shared/InputHelper");

class DonationAmount extends React.Component {
	constructor(props) {
		super(props);

		var state = this.getStateFromStore(props);
		state.focused = false;

		if (props.isDesignMode) {
			state.donationAmount = "0";
		}

		this.state = state;

		this._onChange = this._onChange.bind(this);
	}

	handleBlur() {
		if (this.state.originalDonationAmount === this.state.donationAmount) {
			return;
		}

		if (this.validateMinimumAmount()) {
			this.setState({ focused: false }, () => {
				if (!this.props.isDesignMode) {
					CheckoutActions.updateDonation(this.props.cartItemId);
				}
			});
		}
	}

	validateMinimumAmount() {
		var minimumDonationAmount = this.state.minimumDonationAmount;
		var donationAmount = this.state.donationAmount;
		var errorMessage = "";

		var cartItem = CheckoutStore.getItem(this.props.cartItemId, Constants.CART_ITEM_PROJECT);
		var groupItems = CheckoutStore.getGiftGroupDonationsByGroupId(cartItem && cartItem.groupId);
		var groupItemsCount = groupItems.length;

		if (cartItem && cartItem.cartType !== Constants.CART_TYPES.SAVE_FOR_LATER) {
			if (groupItemsCount > 1 && cartItem.groupId)
			{
				var donationGroupTotal = CheckoutStore.getDonationGroupTotal(this.props.cartItemId);
				if (donationGroupTotal < minimumDonationAmount) {
					errorMessage = CheckoutStore.getWizardValue(
						WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
						WizardConstants.CHECKOUT_MESSAGE_FIELDS.GIFT_GROUP_AMOUNT_INSUFFICIENT,
						{ formattedAmount: ActionsHelper.formatAmount(minimumDonationAmount, true) }
					);

					CheckoutActions.applyInsufficientGiftGroupAmountStyling(this.props.cartItemId);
				}
			} else if (donationAmount < minimumDonationAmount) {
				errorMessage = CheckoutStore.getWizardValue(
					WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
					WizardConstants.CHECKOUT_MESSAGE_FIELDS.GIFT_AMOUNT_INSUFFICIENT,
					{ formattedAmount: ActionsHelper.formatAmount(minimumDonationAmount, true) }
				);
			}
		}

		if (errorMessage) {
			BootstrapPrompt.alert(errorMessage);
			CheckoutActions.setDonationAmount(this.props.cartItemId, ActionsHelper.convertFormattedAmountToNumberString(this.state.originalDonationAmount));
		}

		return !errorMessage;
	}

	handleFocus() {
		this.setState({ focused: true });
	}

	handleAmountChange(event) {
		// Enforce that the value can be a number followed by a decimal and up to two digits
		// valid: 8, 8., ., .8, .88
		// invalid: .888, 8.888, asdf, '8,888'
		if (InputHelper.isAmountValid(event.currentTarget.value)) {
			CheckoutActions.setDonationAmount(this.props.cartItemId, ActionsHelper.convertFormattedAmountToNumberString(event.currentTarget.value));
		}
	}

	formatAmountKeepUserDecimals(amount) {
		return this._formatAmount(amount, true);
	}

	formatAmount(amount) {
		return this._formatAmount(amount, false);
	}

	// If keepDecimals, do not format out the decimals.
	// User entered information should not strip out decimals.
	_formatAmount(amount, keepDecimals) {
		return ActionsHelper.formatAmount(amount, this.props.showDecimals, this.props.includeCurrencySymbol, keepDecimals);
	}

	getStateFromStore(props) {
		return {
			donationAmount: CheckoutStore.getDonationAmount((props || this.props).cartItemId),
			minimumDonationAmount: CheckoutStore.getMinimumDonationAmount((props || this.props).cartItemId)
		};
	}

	_onChange() {
		this.setState(this.getStateFromStore());
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		CheckoutStore.addChangeListener(this._onChange);

		this.setState({originalDonationAmount: CheckoutStore.getDonationAmount(this.props.cartItemId)});
	}

	componentWillUnmount() {
		CheckoutStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			CheckoutActions.setDonationAmount(this.props.cartItemId, null);
		}
	}

	render() {
		var donationAmount = this.state.donationAmount;
		if (!this.state.focused) {
			donationAmount = this.formatAmount(donationAmount);
		} else {
			donationAmount = ActionsHelper.replaceAmountDecimalSymbols(this.state.donationAmount);
		}

		return (
			<span
				data-react-component-name="DonationAmount"
				data-react-component-category="DonationCartItemComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<input
					type="text"
					value={donationAmount}
					maxLength="10"
					onBlur={this.handleBlur.bind(this)}
					onChange={this.handleAmountChange.bind(this)}
					onFocus={this.handleFocus.bind(this)}
					className={this.props.className}
					data-override-classes={this.props.className}
					inputMode="decimal"
				/>
			</span>
		);
	}
}

DonationAmount.defaultProps = {
	includeCurrencySymbol: true,
	showDecimals: true
};

DonationAmount.propTypes = {
	className: PropTypes.string,
	isDesignMode: PropTypes.bool,
	cartItemId: PropTypes.string,
	showDecimals: PropTypes.bool,
	includeCurrencySymbol: PropTypes.bool,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = DonationAmount;
